/**
 * Fix delivery summary bar positioning
 */

(function() {
  'use strict';

  function isMobileSummaryViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function fixDeliveryBarPosition() {
    const deliveryBar = document.querySelector('.delivery-summary-header:not([data-delivery-summary-placeholder])');
    const headerDeliverySummary = document.querySelector('[data-header-delivery-summary]');
    const sectionHeader = document.querySelector('.section-header');

    if (!deliveryBar) return;

    if (isMobileSummaryViewport()) {
      if (headerDeliverySummary && headerDeliverySummary.contains(deliveryBar) && sectionHeader && sectionHeader.parentElement) {
        sectionHeader.parentElement.insertBefore(deliveryBar, sectionHeader.nextSibling);
      }
    } else if (headerDeliverySummary && headerDeliverySummary.contains(deliveryBar)) {
      return;
    }

    deliveryBar.style.setProperty('position', 'relative', 'important');
    deliveryBar.style.setProperty('z-index', '1', 'important');

    const innerBar = deliveryBar.querySelector('.delivery-summary-bar');
    if (innerBar) {
      innerBar.style.setProperty('position', 'static', 'important');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDeliveryBarPosition);
  } else {
    fixDeliveryBarPosition();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (
            node.classList &&
            node.classList.contains('delivery-summary-header') &&
            !node.hasAttribute('data-delivery-summary-placeholder')
          ) {
            setTimeout(fixDeliveryBarPosition, 100);
            break;
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
